import Model3 from '../../svg/model3.svg'
import { Box, SxProps, Theme } from '@mui/material'

export interface DeviceIconProps {
  model: string
  sx?: SxProps<Theme>
}

/**
 * Display an icon for an appliance type.
 */
export const DeviceIcon = (props: DeviceIconProps): JSX.Element => {
  const sx = {
    ...props.sx
  }

  return <Box sx={sx}>
    <img alt="Model3 diagram" width="100%" src={Model3}></img>
  </Box>
}
